import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import ContentWrapper from "../components/ContentWrapper";
import profileImage from "../../src/assets/images/Food_1.png";
import { useDispatch, useSelector } from "react-redux";
import {
  getDetails,
  updateAdminInfo,
  updatePassword,
} from "../Redux/Action/SubAdmin";
import { adminupload } from "../Redux/Action/CareSeekerAction";
import { useFormik } from "formik";
import * as Yup from "yup";
import PasskeySetup from "../components/PasskeySetup";

export default function Setting() {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('profile');

  useEffect(() => {
    dispatch(getDetails());
  }, [dispatch]);
  
  const admindetails = useSelector((state) => state.SubAdmin.admindetails);

  const hadeluploadfile = (event) => {
    const file = event.target.files[0];
    let fileinfo = new FormData();
    fileinfo.append("file", file);
    dispatch(adminupload(fileinfo)).then(function (info) {
      dispatch(
        updateAdminInfo({
          image: info.payload.url,
        })
      ).then(function () {
        dispatch(getDetails());
      });
    });
  };

  const formik = useFormik({
    initialValues: {
      old_password: "",
      password: "",
      new_password: "",
    },
    validationSchema: Yup.object().shape({
      old_password: Yup.string().required("Old Password is required"),
      password: Yup.string().required("Password is required"),
      new_password: Yup.string()
        .required("New Password is required")
        .oneOf([Yup.ref("password")], "Passwords must match"),
    }),
    onSubmit: (value) => {
      dispatch(updatePassword(value));
    },
  });

  const tabs = [
    { id: 'profile', name: 'Profile & Password', icon: '👤' },
    { id: 'security', name: 'Security & Passkeys', icon: '🔒' },
  ];

  return (
    <Layout>
      <ContentWrapper title="Settings">
        <div className="settings-container">
          {/* Tab Navigation */}
          <div className="settings-tabs" style={{ marginBottom: '2rem' }}>
            <div className="tab-buttons" style={{ display: 'flex', borderBottom: '1px solid #e5e7eb', marginBottom: '2rem' }}>
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                  style={{
                    padding: '12px 24px',
                    border: 'none',
                    background: 'none',
                    cursor: 'pointer',
                    borderBottom: activeTab === tab.id ? '2px solid #3b82f6' : '2px solid transparent',
                    color: activeTab === tab.id ? '#3b82f6' : '#6b7280',
                    fontWeight: activeTab === tab.id ? '600' : '400',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    fontSize: '14px'
                  }}
                >
                  <span style={{ fontSize: '16px' }}>{tab.icon}</span>
                  {tab.name}
                </button>
              ))}
            </div>
          </div>

          {/* Tab Content */}
          {activeTab === 'profile' && (
            <div className="profile-settings">
              <div className="profile-page-wrap">
                <div className="upload-preview">
                  <div className="image-preview-wrap">
                    <img
                      src={
                        admindetails?.image !== undefined
                          ? admindetails?.image
                          : profileImage
                      }
                      alt="profile-image"
                    />
                    <label htmlFor="upload-file">{admindetails?.name}</label>
                  </div>
                  <div className="upload-input">
                    <label htmlFor="image-upload">Change Profile Image</label>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        hadeluploadfile(e);
                      }}
                      id="image-upload"
                    />
                  </div>
                </div>
                <form onSubmit={formik.handleSubmit}>
                  <div className="change-password-wrap">
                    <label htmlFor="upload-file">Change Password:</label>
                    <div className="change-pass-uploads">
                      <div className="form-group">
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Current Password"
                          onChange={formik.handleChange}
                          value={formik.values.old_password}
                          onBlur={formik.handleBlur}
                          name="old_password"
                        />
                        {formik.touched.old_password &&
                          formik.submitCount > 0 &&
                          formik.errors.old_password && (
                            <div className="error">
                              {formik.errors.old_password}
                            </div>
                          )}
                      </div>
                      <div className="form-group">
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Password"
                          onChange={formik.handleChange}
                          value={formik.values.password}
                          onBlur={formik.handleBlur}
                          name="password"
                        />
                        {formik.touched.password &&
                          formik.submitCount > 0 &&
                          formik.errors.password && (
                            <div className="error">{formik.errors.password}</div>
                          )}
                      </div>
                      <div className="form-group">
                        <input
                          type="password"
                          className="form-control"
                          placeholder="New Password"
                          onChange={formik.handleChange}
                          value={formik.values.new_password}
                          onBlur={formik.handleBlur}
                          name="new_password"
                        />
                        {formik.touched.new_password &&
                          formik.submitCount > 0 &&
                          formik.errors.new_password && (
                            <div className="error">
                              {formik.errors.new_password}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>

                  <button className="common-btn">Save</button>
                </form>
              </div>
            </div>
          )}

          {activeTab === 'security' && (
            <div className="security-settings">
              <div style={{ marginBottom: '2rem' }}>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem', color: '#1f2937' }}>
                  Security Settings
                </h3>
                <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
                  Manage your account security including passkeys for passwordless authentication.
                </p>
              </div>
              <PasskeySetup />
            </div>
          )}
        </div>
      </ContentWrapper>
    </Layout>
  );
}
